<template>
  <div class="download-button-cell-renderer">
    <a
      v-tooltip="`${params.tooltipText || 'Download'}`"
      class="btn btn-sm btn-secondary"
      :href="`${params.data[params.url]}`"
      :aria-label="`${params.tooltipText || 'Download'}`"
    >
      <i class="bx bx-download" aria-hidden="true" focusable="false" />
    </a>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)
</script>
